import { showErrorToast } from "../../../../../components/common/ShowToast";
import apiService from "../../../../../service/Api";

export const downloadApprovedComments = async (id: string | undefined) => {
  try {
    const response = await apiService.get<ArrayBuffer>(
      `/api/chats/memorial-message/download-approved-csv/?stream_id=${id}`
    );

    const blob = new Blob([response.data], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `Approved Comments - ${id} - ${new Date().toDateString()}`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error(err);
    showErrorToast("Failed to download comments");
  }
};
